import React, { memo, useEffect } from "react";
import { FlexDiv, StyledP } from "base/BaseStyle";
import { useMeasure } from "react-use";
import { useSpring, to } from "@react-spring/web";
import { ReactComponent as ArrowIcon } from "assets/icons/arrow.svg";
import {
  StyledParentItem,
  StyledMenuItem,
  StyledSubItem,
  StyledSubContainer,
} from "../SlideMenu.styles";

const ITEM_HEIGHT = 45;

function MenuItem({
  t,
  item,
  expand,
  changeExpand,
  navigatePath,
  checkFocusPath,
}) {
  const { name, icon, children = [], path } = item || {};
  const [ref, { height }] = useMeasure();
  const containerAnimatedStyle = useSpring({
    height: expand ? height + ITEM_HEIGHT + 10 : ITEM_HEIGHT,
  });

  const subContainerAnimatedStyle = useSpring({
    opacity: expand ? 1 : 0,
    x: expand ? 0 : 30,
  });

  useEffect(() => {
    if (checkFocusPath(path, true) && children.length > 0) {
      changeExpand(name);
    }
  }, []);

  return (
    <StyledMenuItem
      style={containerAnimatedStyle}
      $focus={checkFocusPath(path, true)}
      $isParent={children.length > 0}
      $expand={expand}
    >
      <StyledParentItem
        onClick={() => {
          if (children.length > 0) changeExpand(expand ? "" : name);
          navigatePath(path);
        }}
        height={ITEM_HEIGHT}
      >
        <FlexDiv $gap="10">
          {icon}
          <StyledP fontSize="15">{t(`Menu.${name}`)}</StyledP>
        </FlexDiv>
        {children.length > 0 && <ArrowIcon />}
      </StyledParentItem>
      <StyledSubContainer
        ref={ref}
        style={{
          ...subContainerAnimatedStyle,
          transform: to(
            [subContainerAnimatedStyle.x],
            (value) => `translateX(${value}px)`,
          ),
        }}
      >
        {Array.isArray(children) &&
          children.map((child) => (
            <StyledSubItem
              key={child.name}
              $subFocus={checkFocusPath(child.path)}
              onClick={() => navigatePath(child.path)}
              height={ITEM_HEIGHT}
            >
              <StyledP fontSize="15" $textAlign="left">
                {t(`Menu.${child.name}`)}
              </StyledP>
            </StyledSubItem>
          ))}
      </StyledSubContainer>
    </StyledMenuItem>
  );
}

export default memo(MenuItem);
